var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFlipIcon = function SvgFlipIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.666 22.516c0 1.11-1.174 1.818-2.173 1.324l-8.167-4.05a2.99 2.99 0 0 1-1.66-2.66V9.483c0-1.11 1.174-1.818 2.173-1.324l8.167 4.05a2.99 2.99 0 0 1 1.66 2.66v2.463M17.334 22.516c0 1.11 1.174 1.818 2.173 1.324l8.167-4.05a2.99 2.99 0 0 0 1.66-2.66V9.483c0-1.11-1.174-1.818-2.173-1.324l-8.167 4.05a2.99 2.99 0 0 0-1.66 2.66v2.463",
    stroke: "#2D4FA1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16c3.332 4 6.666 4.667 10.166 3.904 4.5-.98 5.914-4.96 5.914-4.96m0 0L24.666 18m-.586-3.057-3.34.641",
    stroke: "#2D4FA1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { SvgFlipIcon as ReactComponent };
export default __webpack_public_path__ + "static/media/flip-icon.cf229336.svg";